var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.15 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.44,15.23a4.67,4.67,0,0,1-6.7,0,4.41,4.41,0,0,1-.12-6.47L8.91,3.47a2.84,2.84,0,0,1,4.12,0,2.84,2.84,0,0,1,0,4.12L8.91,11.82a1.13,1.13,0,0,1-1.64,0,1.12,1.12,0,0,1,0-1.6.08.08,0,0,1,0,0l3.29-3.3L8.8,5.23,5.62,8.41a3.41,3.41,0,0,0,0,4.94,3.51,3.51,0,0,0,4.94,0L14.8,9.12a5.27,5.27,0,0,0,0-7.53,5.25,5.25,0,0,0-7.53,0L2,7.12a6.88,6.88,0,0,0,.12,9.76A7,7,0,0,0,7.15,19a6.59,6.59,0,0,0,4.94-2.12l5.06-5.06L15.5,10.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8aa3217880b8c685f0b1ea7d8833aca0.svg";
export { ForwardRef as ReactComponent };